import Vue from 'vue';
import Vuex from 'vuex';
import AuthService from '../services/auth.service';

Vue.use(Vuex);

const user = JSON.parse(localStorage.getItem('_auth'));
const initialState = user
  ? {
    isAuth: true,
    uid: user.uid,
    admin: user.admin,
    username: user.username,
    skin: user.skin,
    cloak: user.cloak,
  }
  : { isAuth: false, uuid: null, admin: null, username: null, skin: null, cloak: null };

export default new Vuex.Store({
  state: initialState,
  mutations: {
    login(state, userInfo) {
      state.uuid = userInfo.uuid;
      state.uid = userInfo.uid;
      state.admin = userInfo.admin;
      state.username = userInfo.username;
      state.skin = userInfo.skin;
      state.cloak = userInfo.cloak;
      state.isAuth = true;
    },
    logout(state) {
      state.uuid = null;
      state.isAuth = false;
      state.username = null;
      state.admin = false;
      state.cloak = null;
      state.skin = null;
    },
    register(state, userInfo) {
      state.uuid = userInfo.uid;
      state.isAuth = false;
    },
    refresh(state) {
      state.isAuth = true;
    },
  },
  actions: {
    async login({ commit }, userInfo) {
      return AuthService.login(userInfo)
        .then((userData) => {
          commit('login', userData);
          return Promise.resolve(userData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    async refresh({ commit }, userInfo) {
      return AuthService.refresh(userInfo)
        .then(() => commit('refresh'));
    },
    async register({ commit }, userInfo) {
      return AuthService.register(userInfo)
        .then((userData) => {
          commit('register', userData);
          return Promise.resolve(userData);
        });
    },
  },
  getters: {
    isAuth: state => state.isAuth,
    uid: state => state.uuid,
    admin: state => state.admin,
    username: state => state.username,
    skin: state => state.skin,
    cloak: state => state.cloak,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js